import { render, staticRenderFns } from "./DiscussionChangeActivationType.vue?vue&type=template&id=55f7739e&"
import script from "./DiscussionChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./DiscussionChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports